export var PROPERTIES_BAR_TYPE;
(function (PROPERTIES_BAR_TYPE) {
    PROPERTIES_BAR_TYPE["CONNECTOR"] = "connector";
    PROPERTIES_BAR_TYPE["BLOCK"] = "block";
    PROPERTIES_BAR_TYPE["MAIN"] = "main";
})(PROPERTIES_BAR_TYPE || (PROPERTIES_BAR_TYPE = {}));
export var DELETE_CONFIRMATION_MODAL_TYPE;
(function (DELETE_CONFIRMATION_MODAL_TYPE) {
    DELETE_CONFIRMATION_MODAL_TYPE["CONNECTOR"] = "connector";
    DELETE_CONFIRMATION_MODAL_TYPE["BLOCK"] = "block";
    DELETE_CONFIRMATION_MODAL_TYPE["MAIN"] = "main";
})(DELETE_CONFIRMATION_MODAL_TYPE || (DELETE_CONFIRMATION_MODAL_TYPE = {}));
export var DYNAMIC_MODAL_TYPE;
(function (DYNAMIC_MODAL_TYPE) {
    DYNAMIC_MODAL_TYPE["ICON"] = "icon";
    DYNAMIC_MODAL_TYPE["INPUT"] = "input";
    DYNAMIC_MODAL_TYPE["OUTPUT"] = "output";
})(DYNAMIC_MODAL_TYPE || (DYNAMIC_MODAL_TYPE = {}));
export var RESPONSE_STATUS;
(function (RESPONSE_STATUS) {
    RESPONSE_STATUS["IDLE"] = "idle";
    RESPONSE_STATUS["LOADING"] = "loading";
    RESPONSE_STATUS["SUCCESS"] = "success";
    RESPONSE_STATUS["ERROR"] = "error";
})(RESPONSE_STATUS || (RESPONSE_STATUS = {}));
export var CUSTOM_LOGIC_SUBSCRIPTION_TYPE;
(function (CUSTOM_LOGIC_SUBSCRIPTION_TYPE) {
    CUSTOM_LOGIC_SUBSCRIPTION_TYPE["ARG"] = "arg";
})(CUSTOM_LOGIC_SUBSCRIPTION_TYPE || (CUSTOM_LOGIC_SUBSCRIPTION_TYPE = {}));
